import BannerComp from "../../components/BannerComp";
import FeatureImageContent from "../../components/FeatureImageContent";
import IconBenefitGrid from "../../components/IconBenefitGrid";
import ImageTextSection from "../../components/ImageTextSection";
import ProPrograms from "../../components/ProPrograms";
import Seo from "../../components/Seo";
import { benefitsData, proProgramsData } from "../../data/allergytesting";
import { createBreadcrumbSchema, createWebPageSchema } from "../../lib/seo";
import section1Image from "./allergytesting_section1.webp";
import section2Image from "./allergytesting_section2.webp";
import section3Image from "./allergytesting_section3.webp";

const seo = {
  title: "Allergy Diagnosis & Treatments | MIT4Doctors",
  description:
    "MITSI helps healthcare practices in a big way, bringing easy, affordable diagnostic and treatment solutions for allergy symptoms.",
  schema: [
    createWebPageSchema({
      path: "/services/allergy-testing",
      title: "Allergy Diagnosis & Treatments",
      description:
        "Medical Imaging Technology Services (MITSI) is helping healthcare practices in a big way. We're bringing easy, affordable solutions for allergy symptoms and treatments.",
    }),
    createBreadcrumbSchema(
      "/services/allergy-testing",
      "Allergy Diagnosis & Treatments",
    ),
  ],
};

export default function AllergyTesting() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/services/allergy-testing"
        schema={seo.schema}
      />
      <BannerComp
        heading="Allergy Diagnosis & Treatments"
        paragraph="Medical Imaging Technology Services (MITSI) is helping healthcare practices in a big way. We're bringing easy, affordable solutions for allergy symptoms and treatments."
        centered
        BannerBgImg="/img/banners/allergytesting_hero.webp"
      />

      <ImageTextSection
        image={section1Image}
        imageAlt="Clarity & Accuracy in Allergy Testing"
        imagePosition="left"
        title="Clarity & Accuracy in Allergy Testing"
        description="Our allergy testing program ensures accurate diagnosis for effective allergy management. Our program tests for a wide range of allergens, providing detailed insights into each patient's allergies. Our 72-prick test reduces the risk of misdiagnosis, helping create tailored treatment plans. This accuracy ensures patients get focused, effective care from the start."
        highlightWords="Allergy Testing"
        subHeading="Designed Allergy Testing for Local Triggers"
        subHeadingHighlightWords="Local Triggers"
        subSections={[
          {
            listItems: [
              "Local Focus: Tests for allergens in your region, like pollen, dust, and mold.",
              "Accurate: Provides precise, location-specific diagnoses.",
              "Personalized: Adjusted treatment plans based on local environmental triggers.",
            ],
            listItemBoldText: ["Local Focus", "Accurate", "Personalized"],
          },
        ]}
      />

      <ProPrograms
        heading="Smooth Allergy Testing for Your Practice"
        highlightText="Your Practice"
        description="Our program gives providers a full-service, in-office solution. It eliminates the need for lab facilities, extra staff, or upfront investments. Here’s how MITSI makes allergy care accessible and efficient:"
        programs={proProgramsData}
      />

      <FeatureImageContent
        heading="Affordable, Effective Allergy Testing"
        description="Get accurate, fast allergy tests and revolutionize your work. No starting costs are required. Easy, flexible billing for patients to feel better long-term, and your services run more smoothly."
        buttonLabel="Get Started"
        buttonUrl="/contact-us"
        imageAlt="Affordable, Effective Allergy Testing"
      />

      <ImageTextSection
        image={section2Image}
        imageAlt="Get the Best Allergy Diagnosis with Us"
        imagePosition="right"
        title="Get the Best Allergy Diagnosis with Us"
        description="MITSI offers a unique, hassle-free solution for allergy testing and immunotherapy. It enables practices to provide expert care efficiently. There is no initial cost. It offers comprehensive coverage and all-inclusive support. It enables providers to deliver advanced allergy services efficiently and affordably."
        highlightWords="Allergy Diagnosis"
      />

      <IconBenefitGrid
        title="Who Can Benefit from Immunotherapy?"
        description="Immunotherapy is suitable for individuals with:"
        highlightWords="Immunotherapy?"
        items={benefitsData}
      />

      <ImageTextSection
        image={section3Image}
        imageAlt="Implement Allergy Diagnosis in Your Facility"
        imagePosition="left"
        title="Implement Allergy Diagnosis in Your Facility"
        description="MITSI simplifies exact allergy exams. Our 72-prick test delivers speedy, accurate outcomes. Our package is free of upfront costs. It covers everything, from technician payments to billing. It has complete insurance coverage. Use customized allergy treatments to improve patient results and streamline your work."
        highlightWords="Your Facility"
      />
    </>
  );
}
